// extracted by mini-css-extract-plugin
export default {"slider":"ZInYKHXkFGMLRkgrkg06","input":"MigRVg6wDXUT9rpfNMtl","background":"va_YM_exrH0fsW8Tvjsh","tick":"DaqmqEvNJ4Uaz0GAGLIa","bubble":"iIZO7ZiwrDYm4qtbx54H"};